export default __webpack_public_path__ + "static/media/pie-chart.73375137.png";